import type { ListProduct } from '@/queries/Products';

/**
 * Extracts pricing information from a product, including discount calculations.
 *
 * @param data - The product data containing price and discount information
 * @returns An object containing:
 *   - `price`: The original price (comparePrice if available, otherwise price)
 *   - `discount`: The dollar amount off (price - discountedPrice)
 *   - `discountedPrice`: The final price after discount is applied
 *
 * @example
 * // Product with $100 off
 * getPriceAndDiscount(product)
 * // Returns: { price: 499, discount: 100, discountedPrice: 399 }
 */
export const getPriceAndDiscount = (data: ListProduct | undefined) => {
  const comparePrice = data?.comparePrice?.amount;
  const price = comparePrice ?? data?.price?.amount;
  const discountedPrice = data?.discountedPrice.discountedPrice?.amount ?? 0;
  const discount = price && discountedPrice ? price - discountedPrice : 0;
  return { price, discount, discountedPrice };
};
